import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { ILoaderProps } from "./Loader";

export const useStyles = makeStyles<Theme, ILoaderProps>((theme) => ({
  root: ({ backgroundColor, loaderColor }) => ({
    backgroundColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: loaderColor ?? theme.palette.events.bluePrimary,
  }),
}));
